import { NewsletterOptionProps } from '../../newsletter/types/Newsletter';
import { isUserLoggedIn } from '../../common/Auth';
import { handleUserActionWithLoginCheck } from '../../common/LoggedOutUserActions';

export const handleNewsletterToggle = (
  newsletter: NewsletterOptionProps['newsletter'], // Newsletter object
  isUserPremium: boolean, // Flag indicating if the user is a premium user
  isAlreadySubscribedToPremium: boolean, // Flag indicating if user is already subscribed to premium
  setIsDialogOpen: React.Dispatch<React.SetStateAction<boolean>>, // Function to open or close the modal dialog
  setIsToggleChecked: React.Dispatch<React.SetStateAction<boolean>>, // Function to change the toggle state
  onChange: (newsletter: NewsletterOptionProps['newsletter']) => void, // Change to async
  setIsAlreadySubscribedToPremium: React.Dispatch<React.SetStateAction<boolean>>, // Function to update if user is subscribed to premium
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const isPremiumNewsletter = newsletter.is_premium; // Check if the newsletter is a premium one

  console.log('Newsletter:', newsletter);
  console.log('Is Premium Newsletter:', isPremiumNewsletter);
  console.log('Is User Premium:', isUserPremium);
  console.log('Is Already Subscribed to Premium:', isAlreadySubscribedToPremium);

  // If the newsletter is premium
  if (isPremiumNewsletter) {
    console.log('Handling premium newsletter...');

    if (isUserLoggedIn()) {
      // Check if the user is logged in
      console.log('User is logged in');

      if (isUserPremium) {
        // If the user is premium, allow toggling the subscription
        console.log('User is premium. Toggling subscription.');
        setIsToggleChecked((prevState) => !prevState); // Toggle the subscription state
        onChange(newsletter); // Call the change handler
        return;
      }

      // If the user is already subscribed to premium but isn't a premium user
      if (isAlreadySubscribedToPremium) {
        console.log('User is already subscribed to premium. Unsubscribing.');
        setIsToggleChecked((prevState) => !prevState); // Toggle the subscription state
        onChange(newsletter); // Call the change handler
        setIsAlreadySubscribedToPremium(false); // Set to false after unsubscribing
        return;
      }

      // If the user is not premium and not subscribed, open the premium modal
      console.log('User is not subscribed to premium. Opening premium modal.');
      setIsDialogOpen(true); // Open the dialog for premium subscription
      if (setIsLoading) {
        setIsLoading(false);
      }
      return;
    }

    // If the user is not logged in, prompt for login first
    console.log('User is not logged in. Checking login action...');
    if (!handleUserActionWithLoginCheck('newsletter', newsletter.code, true)) {
      console.log('Login failed or action cancelled.');
      if (setIsLoading) {
        setIsLoading(false);
      }
      return;
    }

    // If login is successful, toggle the subscription
    console.log('Login successful. Toggling subscription.');
    setIsToggleChecked((prevState) => !prevState); // Toggle the subscription state
    onChange(newsletter); // Call the change handler
  } else {
    // For non-premium newsletters
    console.log('Handling regular newsletter...');

    // Check if the user needs to log in before proceeding
    if (!handleUserActionWithLoginCheck('newsletter', newsletter.code)) {
      console.log('Login failed or action cancelled.');
      if (setIsLoading) {
        setIsLoading(false);
      }
      return;
    }

    // If user action is successful, toggle the subscription
    console.log('User action successful. Toggling subscription.');
    setIsToggleChecked((prevState) => !prevState); // Toggle the subscription state
    onChange(newsletter); // Call the change handler
  }
};
